module.exports = __webpack_public_path__ + "3d38a827174a88e17b70c1f59e83d011.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/SubjectHandler/images/img-bg-2.svg
// module id = 898
// module chunks = 9